export class DLMasterModel {
    itemName: string;
    season: string;
    helper: string;
    mainSampleCode2: string;
    productionPlanTypeName: string;
    fabricLeadTime: string;
    trimLeadTime: string;
    poLeadTime: string;
    sam: string;
    keisu: string;
    body: string;
    sleeve: string;
    rib: string;
    ribNkBttm: string;
    sJ: string;
    fleece: string;
    total: string
    constructor(
        itemName: string,
        season: string,
        helper: string,
        mainSampleCode2: string,
        productionPlanTypeName: string,
        fabricLeadTime: string,
        trimLeadTime: string,
        poLeadTime: string,
        sam: string,
        keisu: string,
        body: string,
        sleeve: string,
        rib: string,
        ribNkBttm: string,
        sJ: string,
        fleece: string,
        total: string
    ) {
        this.itemName = itemName;
        this.season = season;
        this.helper = helper;
        this.mainSampleCode2 = mainSampleCode2;
        this.productionPlanTypeName = productionPlanTypeName;
        this.fabricLeadTime = fabricLeadTime;
        this.trimLeadTime = trimLeadTime;
        this.poLeadTime = poLeadTime;
        this.sam = sam;
        this.keisu = keisu;
        this.body = body;
        this.sleeve = sleeve;
        this.rib = rib;
        this.ribNkBttm = ribNkBttm;
        this.sJ = sJ;
        this.fleece = fleece;
        this.total = total;
    }
}